import { FC } from "react";
import { ChatServerButton, ChatServerListItem } from "../../xapp/ChatServerMessage";
import { ActionItemImage } from "../ActionItem";
import { ActionItem } from "../ActionItem/ActionItem";
import { ChatActionButtons } from "../ChatActionButtons";
import { ExternalLink } from "../ExternalLink";
import { SmartLink } from "../SmartLink";
import "./ListItem.scss";
import { OpenUrlCallback } from "../../hooks/useOpenUrlCallback";

export interface ListItemProps {
    readonly item: ChatServerListItem;
    readonly emptyImageVisible?: boolean;
    readonly layout?: "normal" | "titles";
    onButtonClick(button: ChatServerButton): void;
    onExecute(text: string, token?: string): void;
    onOpenUrl: OpenUrlCallback;
}

const ListItem: FC<ListItemProps> = (props) => {
    const { item } = props;

    const layout = props.layout || "normal";

    const url = item.url || item.imageActionUrl;

    return (
        <ActionItem
            className="xappw-vlist-item-container"
            item={item}
            onButtonClick={props.onButtonClick}
            onExecute={props.onExecute}
            onOpenUrl={props.onOpenUrl}>
            <div className={`xappw-vlist-item xappw-vlist-item--${layout}`}>
                <div className="xappw-vlist-item__description">
                    {item.title && (
                        <div className="xappw-vlist-item__title">
                            <span>{item.title}</span>
                        </div>
                    )}
                    {url && !item.hideUrl && (
                        <div className="xappw-vlist-item__link-row">
                            <SmartLink url={url} className="xappw-vlist-item__link" />
                            <ExternalLink url={url} className="xappw-vlist-item__external-link" />
                        </div>
                    )}
                    {item.subTitle && (
                        <div className="xappw-vlist-item__subtitle">
                            <span>{item.subTitle}</span>
                        </div>
                    )}
                    {!!item.buttons?.length && (
                        <ChatActionButtons buttons={item.buttons} onClick={props.onButtonClick} />
                    )}
                </div>
                <div className="xappw-vlist-item__side">
                    <ActionItemImage
                        item={item}
                        className="xappw-vlist-item__img"
                        emptyImageVisible={props.emptyImageVisible}
                    />
                </div>
            </div>
        </ActionItem>
    );
};

export default ListItem;
